import { LocaleHome } from '../en/home'

const home: LocaleHome = {
  pickleballGlobal: 'Sistema de Clasificación Global más Preciso para el Pickleball',
  freePlayers: 'Gratis para todos los Jugadores',
  trustedByTheWorld:
    'Confiado por los clubes de Pickleball de élite en todo el mundo, tours profesionales y jugadores recreativos por igual.',
  ourPhilosophy: 'Nuestra Filosofía',
  innovateGame: 'Innovar el juego.',
  unifySport: 'Unificar el deporte.',
  theMostAccurateGlobal:
    'El sistema de clasificación global más preciso, confiado por los clubes, tours y profesionales de Pickleball de élite en todo el mundo.',
  optimizedAccuracy: 'Optimizado para la Precisión',
  yourDUPRRating: 'Tu clasificación DUPR se calcula por',
  marginVictory: 'Margen de Victoria',
  pointsWon: '(puntos ganados)',
  typeResult: 'Tipo de Resultado',
  recreationalEtc: '(juego recreativo vs. liga, torneos sancionados, etc.)',
  outcome: 'Resultado',
  winLoss: '(victoria o derrota)',
  builtPickleball: 'Diseñado para la Comunidad de Pickleball',
  builtPickleballDesc:
    'Una comunidad inclusiva y progresista merece una clasificación a la altura. Con DUPR, todos los jugadores, independientemente de su edad, género, ubicación o habilidad, son clasificados en la misma escala entre 2.00 y 8.00.',
  whatWeDo: 'Lo que Hacemos',
  aNewWayPlay: 'Una Nueva Forma de Jugar',
  aNewWayPlayDesc:
    'El sistema de clasificación DUPR no pierde información ni datos. Incorpora todo en su algoritmo, haciéndolo el más preciso.',
  searchTheDatabase: 'Buscar en la Base de Datos',
  searchTheDatabaseDesc: 'Explora la base de datos de DUPR con más de 1,000,000 de jugadores de pickleball.',
  findYourClub: 'Encuentra tu Club',
  findYourClubDesc: 'Sigue a tu club para estar al tanto de los próximos eventos.',
  analyzePerformance: 'Analiza tu Rendimiento',
  analyzePerformanceDesc: 'Hace un seguimiento de tu progreso mientras DUPR analiza tu juego.',
  logMatches: 'Registrar Partidas',
  logMatchesDesc: 'Ingresa los puntajes de cada partido, en cualquier momento.',
  connectLocalPlayers: 'Conéctate con Jugadores Locales',
  connectLocalPlayersDesc: 'Encuentra jugadores locales y programa partidas.',
  events: 'Eventos',
  eventsDesc: 'Pon a prueba tus habilidades contra oponentes igualados en eventos con la marca DUPR.',
}

export default home
